import { Row, RenderConfig, TextInput, Column, EMPTY_ARRAY, CheckboxInput, ASSET_TYPE, AssetUploadInputOnS3 } from 'commons-ui';
import _get from 'lodash/get';
import { BULK_SEGMENT_UPDATE_SAMPLE_CSV_URL } from './constants';

export const FORM_FIELD_KEYS = {
	CSV_LINK: 'csvLink',
	CREATED_AT: 'createdAt',
	PURPOSE: 'purpose',
	DELETE: 'toBeDeleted',
	EXPIRE: 'toBeExpired',
	EXPIRY_TIME: 'expiryTime'
};

export const FORM_FIELD_LABELS = {
	[FORM_FIELD_KEYS.CSV_LINK]: 'Upload Bulk Segments CSV',
	[FORM_FIELD_KEYS.CREATED_AT]: 'Created At',
	[FORM_FIELD_KEYS.PURPOSE]: 'Purpose',
	[FORM_FIELD_KEYS.DELETE]: 'To Be Deleted',
	[FORM_FIELD_KEYS.EXPIRE]: 'Add Expiry',
	[FORM_FIELD_KEYS.EXPIRY_TIME]: 'Segment Expiry Time (IST)'
};

export const startExpiryDateDependencyResolver = (props: any, dependencyValues: any) => {
	const deleteFlag = _get(dependencyValues, '0');
	if (deleteFlag) {
		return { required: false, disabled: true };
	}

	return { disabled: false, required: true };
};

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.CSV_LINK]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.CSV_LINK)
		.setLabel(ASSET_TYPE.CSV)
		.setLabel('Upload CSV File')
		.setRenderer(AssetUploadInputOnS3)
		.setRenderProps({
			isEditable: { create: true, edit: false, view: false },
			required: true,
			assetType: ASSET_TYPE.MISC_ASSET,
			usePresignedUrl: true,
			maxFileSizeMB: 15,
			downloadFile: true,
			displayText: 'Sample CSV',
			link: BULK_SEGMENT_UPDATE_SAMPLE_CSV_URL
		}),
	[FORM_FIELD_KEYS.CREATED_AT]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.CREATED_AT)
		.setLabel('Created At')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: false, edit: false, view: false },
			inputType: 'datetime-local',
			format: 'yyyy-dd-mm HH:MM:ss',
			required: false
		}),
	[FORM_FIELD_KEYS.PURPOSE]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.PURPOSE)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.PURPOSE])
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.DELETE]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.DELETE)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.DELETE])
		.setRenderer(CheckboxInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } },
			checked: false
		}),
	[FORM_FIELD_KEYS.EXPIRY_TIME]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.EXPIRY_TIME)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.EXPIRY_TIME])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			inputType: 'datetime-local',
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } },
			dependencies: [FORM_FIELD_KEYS.DELETE],
			dependencyResolver: startExpiryDateDependencyResolver
		})
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.CSV_LINK)]), new Column([new Row(FORM_FIELD_KEYS.CREATED_AT)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.PURPOSE)]), new Column([new Row(FORM_FIELD_KEYS.DELETE)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.EXPIRY_TIME)])])
];
